'use client';

import * as React from 'react';
import { CardsExpandableProps } from './types';
import CardsExpandableItemMobile from './CardsExpandableItemMobile';
import CardsExpandableItemDesktop from './CardsExpandableItemDesktop';
import { BaseCarousel } from 'components/shared/Carousel/BaseCarousel';
import { cn, getColorway } from 'utils/styles';
import { CardGrid } from 'components/shared/Card/CardGrid';
import { carouselClassNames, carouselContentClassNames } from 'components/shared/Card/styles';
import { liveUpdateAttrs } from 'libs/contentful/utils';

const CardsExpandable = ({ sys, cardsExpandableItems, margins, color, sectionName }: CardsExpandableProps) => {
  const { items } = cardsExpandableItems;

  const carouselProps = {
    totalItems: items.length,
    showPaginationThreshold: 3,
    carouselClassName: carouselClassNames(color, ''),
    carouselContentClassName: carouselContentClassNames(margins),
    carouselPaginationClassName: 'hidden',
    'aria-label': 'Cards expandable carousel',
    'aria-roledescription': 'Cards expandable carousel',
    'data-testid': 'cards-expandable-carousel',
  };

  return (
    <section
      className={`w-full ${getColorway(color)}`}
      {...(sectionName && { id: encodeURIComponent(sectionName) })}
      {...liveUpdateAttrs(sys?.id, 'content')}>
      {/* Desktop grid - hidden on mobile with CSS */}
      <div
        className={cn(carouselClassNames(color, ''), carouselContentClassNames(margins), 'hidden sm:block')}
        data-testid="cards-expandable-grid">
        <div className={cn('grid grid-flow-col grid-cols-2 grid-rows-[auto_auto_auto_auto_auto] gap-x-6 w-full')}>
          {items.map((item, i) => (
            <CardsExpandableItemDesktop
              key={item.sys?.id ?? i}
              item={item}
              parentId={sys?.id}
              position={i % 2 === 0 ? 'left' : 'right'}
            />
          ))}
        </div>
      </div>

      {/* Mobile carousel - hidden on desktop with CSS */}
      <div className="block sm:hidden">
        <BaseCarousel {...carouselProps}>
          <CardGrid className="auto-cols-[100%]">
            {items.map((item, i) => (
              <CardsExpandableItemMobile
                key={item.sys?.id ?? i}
                item={item}
                parentId={sys?.id}
                position={i % 2 === 0 ? 'left' : 'right'}
              />
            ))}
          </CardGrid>
        </BaseCarousel>
      </div>
    </section>
  );
};

export default CardsExpandable;
